export default __webpack_public_path__ + "static/media/error-fallback-image.532ea75d.svg";